export const months: string[] = ['ÑÐ½Ð²Ð°ÑÑ', 'ÑÐµÐ²ÑÐ°Ð»Ñ', 'Ð¼Ð°ÑÑÐ°', 'Ð°Ð¿ÑÐµÐ»Ñ', 'Ð¼Ð°Ñ', 'Ð¸ÑÐ½Ñ', 'Ð¸ÑÐ»Ñ', 'Ð°Ð²Ð³ÑÑÑÐ°', 'ÑÐµÐ½ÑÑÐ±ÑÑ', 'Ð¾ÐºÑÑÐ±ÑÑ', 'Ð½Ð¾ÑÐ±ÑÑ', 'Ð´ÐµÐºÐ°Ð±ÑÑ'];
export const days: string[] = ['Ð²ÑÐºÑ', 'Ð¿Ð½', 'Ð²Ñ', 'ÑÑ', 'ÑÑ', 'Ð¿Ñ', 'ÑÐ±'];
